/**
 *
 * PortalAnchorButton
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 11-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import style from './PortalAnchorButton.scss';

const PortalAnchorButton = (props) => {
	const intl = useIntl();
	const navigatorAgent = useNavigate();

	const onClickHandler = (navigationObject) => {
		if (navigationObject.externalNavigation) {
			if (navigationObject.externalNavigation.openInNewTab)
				return window.open(navigationObject.externalNavigation.url, '_blank');

			window.location = navigationObject.externalNavigation.url;
		}

		navigatorAgent(navigationObject.internalNavigation.route, {
			replace: navigationObject.internalNavigation.isReplace,
		});
	};

	const wrappedOnClickHandler = () => {
		if (!props.isDisabled) return props.onClickAction ? props.onClickAction() : onClickHandler(props.navigationObject);
	};

	return (
		<Button
			color={props.color}
			variant='text'
			startIcon={props.startIcon ? <i className={props.startIcon} /> : null}
			disabled={props.isDisabled}
			onClick={wrappedOnClickHandler}
			size={props.componentSize}
			className={`
        ${style.container}
        ${props.textTransform && style[props.textTransform]}
        ${props.className}
      `}>
			<Typography variant='overline' className={style.text}>
				{props.isTranslatedMessage ? intl.formatMessage(props.contentText) : props.contentText}
			</Typography>
		</Button>
	);
};

PortalAnchorButton.propTypes = {
	navigationObject: PropTypes.oneOfType([
		PropTypes.exact({
			externalNavigation: PropTypes.exact({
				openInNewTab: PropTypes.bool,
				url: PropTypes.string,
			}),
		}),
		PropTypes.exact({
			internalNavigation: PropTypes.exact({
				isReplace: PropTypes.bool,
				route: PropTypes.string,
			}),
		}),
	]),
	contentText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	isTranslatedMessage: PropTypes.bool,
	onClickAction: PropTypes.func,
	isDisabled: PropTypes.bool,
	componentSize: PropTypes.oneOf(['small', 'medium', 'large']),
	className: PropTypes.string,
	startIcon: PropTypes.node,
	color: PropTypes.oneOf(['primary', 'secondary']),
	textTransform: PropTypes.oneOf(['isCapitalize', 'isUppercase']),
};

PortalAnchorButton.defaultProps = {
	contentText: {},
	isDisabled: false,
	componentSize: 'medium',
	isTranslatedMessage: true,
	className: '',
	startIcon: null,
	color: 'primary',
	textTransform: '',
};

export default PortalAnchorButton;
